<ambita-cadastre-report>
  <ambita-cadastre-report-error/>
  <ambita-cadastre-report-summary product-name="cadastreReport" summary-link-handler="{ opts.summaryLinkHandler }"
                                  property-address-key="{ opts.propertyAddressKey }"/>
  <ambita-cadastre-report-cadastre-sections has-cadastre-click-handler="{ opts.hasCadastreClickHandler }"/>
  <ambita-cadastre-report-owners/>
  <ambita-cadastre-report-conveyance/>
  <ambita-cadastre-report-cadastre-info has-cadastre-click-handler="{ opts.hasCadastreClickHandler }"/>
  <ambita-cadastre-report-addresses/>
  <ambita-cadastre-report-buildings/>

  <script>
    import './sections/buildings.tag';
    import './sections/addresses.tag';
    import './sections/cadastreInfo.tag';
    import './sections/conveyance.tag';
    import './sections/cadastreSections.tag';
    import './sections/owners.tag';
    import './cadastreReportSummary.tag';
    import './cadastreReportError.tag';
    import './cadastreReport.scss';
    import './cadastreReportPrint.scss';
    import '../../i18n/propertyLookupTranslations';
    import { init } from './cadastreReportController';

    init(this);
  </script>
</ambita-cadastre-report>
